 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-050f186e":"ba877679","chunk-07987d0f":"2eb9fc24","chunk-146f9c89":"f350c8c9","chunk-1a82ca8e":"dd0c569e","chunk-1edac8c4":"e6699401","chunk-22e3ef56":"5b1e2081","chunk-263f827c":"951da69c","chunk-2a05e8a6":"e7cab8bf","chunk-2abbd434":"cefb81b8","chunk-2d207410":"503da921","chunk-30c9cb0b":"f10cba5d","chunk-486d1e44":"2258895e","chunk-afb0331c":"4be0f78b","chunk-f5168a7a":"91f65d7d","chunk-fb6573d0":"90009314","chunk-494b6248":"2751baf5","chunk-4b1e2384":"89d19555","chunk-4e55f798":"326e6a11","chunk-563806ad":"209b8e7e","chunk-6ae6ebfa":"6f4af33b","chunk-6dfaf726":"647641a5","chunk-76ea162b":"51ba0386","chunk-7c3c6ed6":"b1d8fb24","chunk-9a6e803a":"71ee4326","chunk-0c15d392":"0e65f343","chunk-104bdf42":"7a63c298","chunk-27335572":"af1041fc","chunk-32e0b3b7":"d69022c8","chunk-3ae196a7":"2ceb9c6d","chunk-43c250ad":"87931ac9","chunk-a2e8d908":"5fb3a352","chunk-a8f362f8":"40938d33","chunk-baba7792":"c5680961","chunk-c8fb371a":"f76c53bb","chunk-cfed271e":"8a8ac586","chunk-d15e267c":"78f92c67","chunk-ef1010f0":"0d78a4d7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-050f186e":1,"chunk-07987d0f":1,"chunk-146f9c89":1,"chunk-1a82ca8e":1,"chunk-1edac8c4":1,"chunk-22e3ef56":1,"chunk-263f827c":1,"chunk-2a05e8a6":1,"chunk-2abbd434":1,"chunk-30c9cb0b":1,"chunk-486d1e44":1,"chunk-afb0331c":1,"chunk-f5168a7a":1,"chunk-fb6573d0":1,"chunk-494b6248":1,"chunk-4b1e2384":1,"chunk-4e55f798":1,"chunk-563806ad":1,"chunk-6ae6ebfa":1,"chunk-6dfaf726":1,"chunk-76ea162b":1,"chunk-7c3c6ed6":1,"chunk-9a6e803a":1,"chunk-27335572":1,"chunk-32e0b3b7":1,"chunk-3ae196a7":1,"chunk-a2e8d908":1,"chunk-a8f362f8":1,"chunk-baba7792":1,"chunk-c8fb371a":1,"chunk-cfed271e":1,"chunk-d15e267c":1,"chunk-ef1010f0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-050f186e":"9e8cb4e1","chunk-07987d0f":"8281e4c9","chunk-146f9c89":"1626e46b","chunk-1a82ca8e":"25789daf","chunk-1edac8c4":"61e2cefe","chunk-22e3ef56":"9cdc6f03","chunk-263f827c":"7d847046","chunk-2a05e8a6":"b95bfd36","chunk-2abbd434":"70c16597","chunk-2d207410":"31d6cfe0","chunk-30c9cb0b":"4543cf5d","chunk-486d1e44":"57f845c5","chunk-afb0331c":"8fc0757f","chunk-f5168a7a":"018fde3a","chunk-fb6573d0":"77232792","chunk-494b6248":"49f96e48","chunk-4b1e2384":"7671cc49","chunk-4e55f798":"c5064077","chunk-563806ad":"420c0a15","chunk-6ae6ebfa":"1430ae90","chunk-6dfaf726":"e9ce5ea7","chunk-76ea162b":"a8428b94","chunk-7c3c6ed6":"2fb59660","chunk-9a6e803a":"b2fc8ef6","chunk-0c15d392":"31d6cfe0","chunk-104bdf42":"31d6cfe0","chunk-27335572":"dbaacc26","chunk-32e0b3b7":"d4ee54f7","chunk-3ae196a7":"00dade7a","chunk-43c250ad":"31d6cfe0","chunk-a2e8d908":"03e9903d","chunk-a8f362f8":"fd69d22e","chunk-baba7792":"6d04330a","chunk-c8fb371a":"461b4d0e","chunk-cfed271e":"e04c520e","chunk-d15e267c":"9ac25129","chunk-ef1010f0":"2d2cd8a6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/tecleando/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
